export const environment = {
  envName: 'production',
  production: true,
  enableVConsole: false,
  base_url: 'https://smartloan-api.starmoney.co.th/api',
  api_key_camera_log: 'E1HIufNagkiVJUoqaQDobzuC9U9ejf73',
  version: '2.0.17',
  updated_at: '20261015'
};
